import { useRef, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import axios from "axios";
import { routes } from "../gen/General";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { do_logout } from "../sec/actions";
import { useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

export const JedaiIdle = () => {
    const [open, setOpen] = useState(false);
    const time = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();

    function handleOnIdle() {
        setOpen(true);
        time.current = setTimeout(doLogout, 30 * 1000);
    }

    const { getRemainingTime } = useIdleTimer({
        timeout: 1000 * 60 * 15, // 15m
        onIdle: handleOnIdle,
        //onActive: handleOnActive,
        //onAction: handleOnAction,
        debounce: 500,
    });

    function doLogout() {
        clearTimeoutId();

        let isMobil = sessionStorage.getItem("uqai");
        sessionStorage.clear();
        let url = isMobil ? "/" : "/login/666";
        axios
            .post(routes.root + "/logout")
            .then(ignored => {
                history.push(url);
            })
            .catch(error => {
                history.push(url);
            })
            .then(() => dispatch(do_logout()))
            .then(() => {
                history.push(url);
            });
    }

    function clearTimeoutId() {
        if (time.current) {
            clearTimeout(time.current);
        }
    }

    function reactivate() {
        // check if already died, in mobile for some reaseon, this time no crurent run after timeout
        if (getRemainingTime() < 1 && open) {
            doLogout();
            return;
        }
        // make fake call to server to mantain alive
        axios.post(routes.api);
        clearTimeoutId();
        setOpen(false);
    }

    return (
        <>
            {open && (
                <Modal className="text-center modal-xlx" isOpen={open}>
                    <ModalBody className={"pt-2 mb-3"}>
                        <p>
                            Ha permanecido inactivo por 15 minutos, presione aceptar para continuar, caso contrario su
                            sesión terminará en 30 segundos.
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <button className={"btn btn-primary mx-auto"} onClick={reactivate}>
                            Continuar
                        </button>
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
};
